import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

/**
 * WeeklyRecapCard — toggle the Sunday recap email and send a one-off
 * preview. `parentSave()` is the shared "save all preferences" handler
 * on the Settings page so the two forms save with one button.
 */
export default function WeeklyRecapCard({ recapOptOut, setRecapOptOut, saving, parentSave, t }) {
  const [sending, setSending] = useState(false);

  const sendRecapNow = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/insights/send-weekly-recap");
      if (data?.sent) {
        if (recapOptOut) {
          toast.success("Preview recap sent", {
            description: "This is a one-off preview — you're still opted out of the weekly Sunday send.",
          });
        } else {
          toast.success("Recap email sent — check your inbox");
        }
      } else {
        toast.error(data?.message || "Could not send recap");
      }
    } catch (e) {
      console.error("Recap send failed:", e);
      toast.error("Could not send recap");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="card-flat p-6" data-testid="settings-weekly-recap">
      <div className="label-eyebrow mb-4">{t("settings.weekly_recap")}</div>
      <p className="text-sm text-[var(--text-secondary)] leading-relaxed mb-4">
        {t("settings.weekly_recap_body")}
      </p>
      <label className="flex items-center gap-3 mb-4 cursor-pointer">
        <input
          type="checkbox"
          checked={!recapOptOut}
          onChange={(e) => setRecapOptOut(!e.target.checked)}
          className="h-5 w-5 accent-[var(--accent-primary)]"
          data-testid="settings-recap-toggle"
        />
        <span className="text-sm text-[var(--text-primary)]">
          {t("settings.weekly_recap_toggle")}
        </span>
      </label>
      <div className="flex flex-wrap gap-3">
        <button
          className="btn-primary"
          onClick={parentSave}
          disabled={saving}
          data-testid="settings-recap-save-btn"
        >
          {saving ? t("common.saving") : t("settings.weekly_recap_save")}
        </button>
        <button
          className="btn-ghost"
          onClick={sendRecapNow}
          disabled={sending}
          data-testid="settings-recap-preview-btn"
        >
          {sending ? t("common.saving") : t("settings.weekly_recap_test")}
        </button>
      </div>
      {recapOptOut && (
        <div
          className="mt-3 text-[11px] text-[var(--text-muted)] leading-relaxed"
          data-testid="settings-recap-optout-note"
        >
          {t("settings.weekly_recap_optout_note")}
        </div>
      )}
    </div>
  );
}
